import { useStore } from 'vuex';

export default function redirectToHomeMiddleware(to, from, next) {
  const store = useStore();
  const isLogged = store.getters['authentication/isLogged'];
  const user = store.getters['authentication/getUser'];

  if (isLogged && user.registration_complete) {
    const playerActive = store.state.player.playerActive;
    const playerCollapsed = store.state.player.playerCollapsed;

    if (playerActive && !playerCollapsed) {
      store.commit('player/setPlayerCollapse', true);
    }

    next('/main/home');
  } else {
    next();
  }
}
